<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-credit-card-alt"></i> Stats</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="columns is-multiline">
                    <div class="column is-4">
                        <div class="box notification is-primary">
                            <div class="heading">Current balance</div>
                            <div class="title">${{stats.current}}</div>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="box notification is-info">
                            <div class="heading">Referred users</div>
                            <div class="title">{{stats.referrals}}</div>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="box notification is-danger">
                            <div class="heading">Total earned</div>
                            <div class="title">${{stats.earned}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <affiliates-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="affiliates" v-bind:actions="true"></affiliates-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import UserRepo from '../../repos/UserRepo'
import AffiliateRepo from '../../repos/AffiliateRepo'
import lodash from 'lodash'
import AffiliatesTable from "./Table";

export default {
  name: 'affiliates-view',
  components: {AffiliatesTable},
  data() {
        return {
            repo: new UserRepo(this.$auth),
            affiliateRepo: new AffiliateRepo(this.$auth),
            affiliates: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
            stats: {
                referrals: 0,
                earned: 0.00,
                current: 0.00
            }
        }
  },
  created(){
      this.getAffiliate();
      this.getStats();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getAffiliate();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getAffiliate();
    },
    onPageChanged(page){
        this.page = page;        
        this.getAffiliate();
    },
    getAffiliate(){
        this.repo.myAffiliatePaginate(this.page, this.q, this.orderBy).then(response => {
            this.affiliates = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
      getStats(){
          this.affiliateRepo.myStats().then(response => {
              this.stats = response.data.data;
          });
      },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/stats/View.vue